(function($){
	OH.settings.headerControl = (function(){
		var control = new Object();

		var $targetHeader, utilbar, $hero;
		var utilbarHeight = function(){
			if(!utilbar){
				return 0;
			}
			return utilbar.offsetTop + utilbar.offsetHeight;
		};
    /*
		$(function(){
			var mainHeader = document.querySelector("BODY > HEADER.l-header");
			var headerWrap = document.createElement("div");
			headerWrap.style.overflow = "hidden";
			headerWrap.style.width = "100%";
			mainHeader.parentNode.insertBefore(headerWrap, mainHeader);
			headerWrap.appendChild(mainHeader);
		});
    */
		// 初期化を兼ねる
		control.stickey = function($header){
			utilbar = document.getElementById("l-utility");
			var topPageFlg = false;
			var mainVisual = document.getElementById('mainVisual');
			var $sp_header = $("#l-utility");
			if(mainVisual){
				topPageFlg = true;
			}
			var urgentNews = $('.oc-urgent-visual').length;
			//緊急のお知らせがあるかどうかの判定処理
			console.log(urgentNews);
			if(urgentNews) {
				$header.addClass('is-urgent-news');
				$sp_header.addClass('is-urgent-news');
				topPageFlg = true;
			}
			if(!topPageFlg){
				$header.addClass('is-pages');
			}
	  		// feature詳細画面のflag
//			var featureMainVisual = document.getElementById('featureMainVisual');
//			if(featureMainVisual) {
//				$header.addClass('is-page-feature');
//			}
			$(window).on("scroll load resize", function(){
				var scrollTop = window.scrollY || document.documentElement.scrollTop;
				var headerHeight = $header.height() + 'px';
				if((window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) <= 840 ){
					if(scrollTop == 0 && topPageFlg){
						$(utilbar).removeClass("is-fixed");
						$header.removeClass("is-fixed");
						$('.c-spnav').removeClass("is-fixed");
						$('body').css('padding-top','');
					}
					else if(scrollTop > utilbarHeight()){
						$(utilbar).addClass("is-fixed");
						$header.addClass("is-fixed");
						// control.setLogoSource();
						$('.c-spnav').addClass("is-fixed");
						$('body').css('padding-top','50px');
					} else if(!topPageFlg){
						$(utilbar).addClass("is-fixed");
						$header.addClass("is-fixed");
						$('body').css('padding-top','50px');
					}
				}
				// else if(scrollTop > utilbarHeight()){
				else if(scrollTop > 30){
					$(utilbar).addClass("is-fixed");
					$header.addClass("is-fixed");
		      //	control.setLogoSource();
				}
				else{
					$(utilbar).removeClass("is-fixed");
					$header.removeClass("is-fixed");
					$('body').css('padding-top','');
				}
			});
			$targetHeader = $header;
			$hero = $('.l-hero').eq(0);
		};

		control.setLogoSource = function(src){
			var $logo = $targetHeader.find('.l-header__logo img').eq(0);
			var currentSrc = $logo.attr("src");
			src = !!src ? src : OH.settings.headerDefine.logoURL.general
			if(currentSrc.indexOf(src) >= 0){
				return;
			}
			var $parent = $logo.parent();
			$logo.remove();
			$parent.append(OH.settings.headerDefine.createLogoElement(src));
		};

		control.setFgAgainstBg = function(hsv){
			var className = hsv.m > 50 ? "txt-333" : "txt-fff";
			$(utilbar).removeClass("txt-333");
			$(utilbar).removeClass("txt-fff");
			$(utilbar).addClass(className);

			$targetHeader.removeClass("txt-333");
			$targetHeader.removeClass("txt-fff");
			$targetHeader.addClass(className);

			$hero.removeClass("txt-333");
			$hero.removeClass("txt-fff");
			$hero.addClass(className);
		};

		control.frontpageLogo = function(logo){
			var logo4fixed = logo.cloneNode(true);
			var switchLogo = function(forceFixFlag){
				var scrollTop = window.scrollY || document.documentElement.scrollTop;
				var fix = forceFixFlag != null ? forceFixFlag : (scrollTop > utilbarHeight());
				logo.style.display = fix ? "" : "none";
				logo4fixed.style.display = fix ? "none" : "";
			}

			$(window).on("scroll resize", function(){
				switchLogo();
			});

			OH.settings.switchLogo = switchLogo;
			logo4fixed.style.display = "none";
			logo.parentNode.insertBefore(logo4fixed, logo);
			switchLogo();
		};

    /**
     * main visualにmenuがかぶってる場合のテキストカラー変換
     */
     control.menuOverMainVisual = function($header,$mainVisual,$spHeader){
       var escapeVisual = function(){
		var mainVisualHeight = $($mainVisual).height();
		var scrollTop = window.scrollY || document.documentElement.scrollTop;
        //  var $targetDom = $($mainVisual).prev($header).find('.l-header__nav');
         var $targetDom = $($header);
		 var $spTargetDom = $($spHeader);
         var isSpMode = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < 1100 ;
         mainVisualHeight = (mainVisualHeight === null) ? 0 : mainVisualHeight;
         if(scrollTop > mainVisualHeight || (isSpMode && scrollTop >= mainVisualHeight)){
           if(isSpMode){
             $spTargetDom.addClass('is-out_main_visual');
             $targetDom.addClass('is-out_main_visual');
            //  $('.c-spnav').addClass("is-fixed");
           }else if(scrollTop >= 50){
             $targetDom.addClass('is-out_main_visual');
           }
         }else if(scrollTop <= mainVisualHeight || scrollTop < 50){
             $spTargetDom.removeClass('is-out_main_visual');
             $targetDom.removeClass('is-out_main_visual');
            //  $('.c-spnav').removeClass("is-fixed");
         }else{
           $targetDom.removeClass('is-out_main_visual');
         }
       }

       $(window).on('load scroll resize',function(){
         escapeVisual();
       });

     }

     /**
      * current ページのときのcurrent class add
      * 1階層のみ対応
      */
      control.currentClassAdd = function($menuListItem,$child,hashtype){
        var pageURL = document.location.href;
        var matchString = $menuListItem.find($child).attr('href');
        /**
         * urlからcategoryマッチ
         */
        if(pageURL.match(matchString) && !hashtype){
          $menuListItem.addClass('current_pages');
        }else if(hashtype){
          var matchHashString = $menuListItem.data('hash');
          if(pageURL.match(matchHashString)){
            var hash = $menuListItem.data('hash');
            document.location.hash = hash;
            $menuListItem.addClass('current_pages');
            $('.shop_menu .shop_menu__item:eq(0)').removeClass('current_pages');
          } else if( $menuListItem.data('hash') === 'all'){
            $('.shop_menu .shop_menu__item:eq(0)').addClass('current_pages');
          }
          
        }
      }


      /**
       * social button の　google タグ　挿入
       */
      //  onclick="send_ga('send', 'event', 'Footer Area', 'Click', 'https://www.instagram.com/omotesandohills_official/', {'nonInteraction' : 1});"
      //  onclick="send_ga('send', 'event', 'Footer Area', 'Click', 'https://www.facebook.com/omotesandohills', {'nonInteraction' : 1});"
      //  onclick="send_ga('send', 'event', 'Footer Area', 'Click', 'https://twitter.com/omohills', {'nonInteraction' : 1});"

		return control;
	})();
})(jQuery);
